// extracted by mini-css-extract-plugin
module.exports = {"btn":"style-module--btn--35zYD","secondary":"style-module--secondary--2TOy0","disabled":"style-module--disabled--2zubQ"};